export default __webpack_public_path__ + "339f210119c1f6b1a677ed7a47a85dfd.png";